import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { OnboardingButton } from '../../../../components/onboarding/OnboardingButton';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  padding: 30px 0;
`;

const Modal = styled.div`
  position: relative;
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  width: 100%;
  max-width: 600px;
  box-shadow: 10px 10px 0px 0px #5BB7E7;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 767px) {
    width: 90%;
    padding: 25px 15px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 25px;
  font-size: 36px;
  border: none;
  background: none;
  cursor: pointer;
  color: #333;

  &:hover {
    color: #000;
  }

  @media (max-width: 767px) {
    font-size: 28px;
    top: 15px;
    right: 15px;
  }
`;

const Title = styled.h2`
  font-family: "Roboto Slab", serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 1.4;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 10px;

  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

const Content = styled.p`
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.4;

  @media (max-width: 767px) {
    font-size: 18px;
  }
`;

const ButtonDiv = styled.div`
  display: flex;
  justify-content: center;
`;

const CongratulationPostsPopup = ({ onClose }) => {
  const navigate = useNavigate();

  const goToPostsPage = () => {
    onClose();
    navigate("/posts");
  };

  return (
    <Overlay className="modalContainerOverlay">
      <Modal className="modalContainer">
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Title>Congratulations! Your AI Is Ready!</Title>
        <Content>Your AI-generated comments are now personalized to you.</Content>
        <ButtonDiv>
          <OnboardingButton
            title="Let’s start commenting"
            style={{ maxWidth: "max-content" }}
            onClick={goToPostsPage}
          />
        </ButtonDiv>
      </Modal>
    </Overlay>
  );
};

export default CongratulationPostsPopup;
